<template>

    <div>
        <Head title="CID/CIAP" />

        <div class="shadow_box rounded-lg p-6">
            <h1 class="mb-6 text-2xl text-gray-777 font-roboto uppercase">CID/CIAP</h1>

            <div>
                <select-input v-model="category" class="lg:pr-6 my-4 w-full lg:w-1/3" label="Tipo do Problema">
                    <option v-for="(value, name) in careplanType" :key="value" :value="value">{{ value }}</option>
                </select-input>
            </div>

            <data-table 
                v-if="loadTable"
                v-model:columns="columns"
                route="cid/list"
                :query="getQuery()"
                no-data-label="Nenhum dado cadastrado"
                no-result-label="Nenhum dado encontrado">
                <template #after.reload-button>
                    <a href="/cid/download-template" class="font-roboto font-medium btn-blue uppercase">
                        <font-awesome-icon icon="fa-download" class="text-white text-lg mr-0 lg:mr-2" />
                        Baixar modelo
                    </a>

                    <button type="button" class="flex items-end font-roboto font-medium btn-blue uppercase cursor-pointer" @click="handleImportDocument">
                        <font-awesome-icon icon="fa-table-cells" class="text-white text-lg mr-0 lg:mr-2" />
                        <span class="hidden lg:block">Importar planilha</span>
                    </button>
                </template>

                <template #table.cell.content.actions="{ value, row }">
                    <button type="button" class="w-10 h-10" @click="handleDelete( value )">
                        <font-awesome-icon icon="fa-trash-can" class="text-red-600 text-lg cursor-pointer" />
                    </button>
                </template>
            </data-table>
        </div>
    </div>

    <modal-edit ref="modalEdit" title="Importar documento" url="cid" @submitForm="handleSubmit" multipart>
        <template #form="{ item }">
            <p class="text-base font-poppins w-full">Importe um documento csv ou xlsx(excel).</p>

            <select-input v-model="item.category" :error="item.errors.category" class="lg:pr-6 mt-4 w-full lg:w-1/2" label="Tipo do Problema">
                <option v-for="(value, name) in careplanType" :key="value" :value="value">{{ value }}</option>
            </select-input>

            <file-input v-model="item.file" :error="item.errors.file" class="mt-6 w-full" type="file" accept=".csv,.xlsx" label="Arquivo" />
        </template>
    </modal-edit>

</template>

<script>

import { Head } from '@inertiajs/inertia-vue3'

import Layout from '@/Shared/Layout'
import DataTable from '@/Shared/DataTable'
import ModalEdit from '@/Shared/ModalEdit'
import FileInput from '@/Shared/FileInput'
import SelectInput from '@/Shared/SelectInput'
import axios from 'axios'


const columns = [
    {
        uniqid: 'category',
        label: 'Categoria',
        field: 'category',
        visible: true,
        sortable: false,
        sortOrder: 'asc',
        classes: 'px-4 py-3 border-b text-sm',
        headerClass: 'p-4 text-left',
    },
    {
        uniqid: 'type',
        label: 'Tipo',
        field: 'type',
        visible: true,
        sortable: false,
        sortOrder: 'asc',
        classes: 'px-4 py-3 border-b text-sm',
        headerClass: 'p-4 text-left',
    },
    {
        uniqid: 'description',
        label: 'Descrição',
        field: 'description',
        visible: true,
        sortable: false,
        sortOrder: 'asc',
        classes: 'px-4 py-3 border-b text-sm',
        headerClass: 'p-4 text-left',
    },
    {
        uniqid: 'actions',
        label: 'Ações',
        field: 'id',
        visible: true,
        sortable: false,
        sortOrder: 'asc',
        classes: 'px-4 py-3 border-b text-sm',
        headerClass: 'w-[200px] p-4 text-left',
    }
]


export default {
    components: {
        Head, DataTable, ModalEdit, FileInput, SelectInput,
    },

    layout: Layout,

    props: [ 'careplanType' ],

    data() {
        return {
            loadTable: true,
            category: '',
        }
    },

    watch: {
        category() {
            this.reloadTable()
        }
    },

    methods: {
        reloadTable() {
            this.loadTable = false;
            setTimeout(() => this.loadTable = true, 10);
        },

        handleSubmit() {
            this.reloadTable();
        },

        handleImportDocument() {
            this.$refs.modalEdit.openModalEdit({
                category: null,
                file: null,
            })
        },

        getQuery() {
            return `category=${ this.category }`
        },

        async handleDelete( id ) {
            try {
                const response = await axios.delete( `/cid/${ id }` )
                this.reloadTable()
                this.$toast.success( response.data.message )
            }
            catch ( err ) {
                this.$toast.error( err.response.data.message )
            }
        },
    },

    setup() {
        return {
            columns,
        }
    }
}

</script>
